import { authenticatedApiRequest } from './authenticatedApi';

const callKajabiApi = (action, accessToken = '') => authenticatedApiRequest('/api/kajabi', {
    method: 'POST',
    body: JSON.stringify({ action }),
}, accessToken);

// The server derives the contact email from the authenticated Supabase user.
export const getKajabiUserData = (accessToken = '') => callKajabiApi('user-data', accessToken);

export const getKajabiOfferLists = () => callKajabiApi('offers');
